import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText, Label, Dropdown } from "../../../../components/Inputs";
import CompanyAddressForm from "./CompanyAddressForm";
import PersonForm from "./PersonForm";

function toTwoDigits(n) {
  return n > 9 ? "" + n : "0" + n;
}

const DebitorForm = React.forwardRef(function DebitorForm(
  {
    className = "",
    model = {
      region: {
        name: "",
        debitorKey: "",
      },
      name: "",
      debitorKey: "",
      company_id: "",
      person: {
        id: "",
        firstname: "",
        lastname: "",
        cellNumber: "",
        telephoneNumber: "",
        email: "",
      },
      comment: "",
    },
    regions = [],
    workers = [],
    contractors = [],
    isCompanySpecialKDL,
    company,
    getCompany,
    disabled,
  },
  ref,
) {
  const addressFormRef = React.useRef(null);
  const personFormRef = React.useRef(null);

  const [state, setState] = React.useState(() => {
    let region = model.region ? model.region : "";
    if (regions.length === 1 && region === "") {
      region = regions[0].name;
    }
    let debitorKey = model.debitorKey || "";
    if (debitorKey === "") {
      const currentRegion = regions.find((item) => item.name === region);
      if (currentRegion) {
        if (isCompanySpecialKDL) {
          debitorKey = "wird generiert";
        } else {
          debitorKey = [
            "R" + region, // toTwoDigits(parseInt(region)),
            currentRegion.debitorKey,
            toTwoDigits(parseInt(currentRegion.suffix) + 1),
          ].join("-");
        }
      }
    }
    return {
      region: region,
      debitorKey: debitorKey,
      comment: model.comment || "",
      error: {
        region: null,
        debitorKey: null,
      },
    };
  });

  const validate = (noValidate) => {
    const { error, ...modelData } = state;
    // check if all values are set
    const newError = { ...error };
    let isValid = true;
    Object.keys(newError).forEach((key) => {
      if (modelData[key] === "") {
        newError[key] = true;
        isValid = false;
      }
    });
    if (!noValidate && !isValid) {
      setState((prev) => ({ ...prev, error: newError }));
      return null;
    }

    // person (optional)
    const person = personFormRef.current.getModel();
    if (person) {
      modelData.person = person;
    }
    // address (required)
    const addressModel = addressFormRef.current.getModel();
    if (!noValidate && !addressModel) {
      return null;
    }
    if (addressModel) {
      const { name, company_id, address } = addressModel;
      modelData.name = name;
      modelData.company_id = company_id;
      modelData.address = address;
    }
    const { id, index, status_id } = model;
    return { id, index, status_id, ...modelData };
  };

  React.useImperativeHandle(ref, () => ({
    getModel: (noValidate) => validate(noValidate),
  }));

  const onRegionChange = (value) => {
    const region = regions.find((item) => item.name === value);
    let debitorKey;
    if (isCompanySpecialKDL) {
      debitorKey = "wird generiert";
    } else {
      debitorKey = [
        "R" + value,
        region.debitorKey,
        toTwoDigits(parseInt(region.suffix) + 1),
      ].join("-");
    }
    setState((prevState) => ({
      ...prevState,
      region: value,
      debitorKey: debitorKey,
      error: {
        ...prevState.error,
        region: null,
      },
    }));
  };

  const { company_id, name, address, person, inUse } = model;
  const { region, debitorKey, comment, error } = state;
  const companyAddress = { company_id, name, address };
  const regionOptions = regions.map((item) => ({
    label: item.name,
    value: item.name,
  }));
  return (
    <div className={className}>
      <div className="neg-margin-lr">
        <div className="w3-row">
          <div
            className={`w3-col s6 pad-lr pad-top form-group-item${
              error.region ? " error-group" : ""
            }`}
          >
            <Label htmlFor="regionOptions">{`Region*`}</Label>
            <Dropdown
              id="regionOptions"
              data-test-id="regionOptions"
              className="w3-block w3-border"
              value={region}
              options={regionOptions}
              onChange={(event) => onRegionChange(event.value)}
              // showClear
              disabled={disabled || inUse}
            />
            {error.region && (
              <div className="error-label pad-sm-top">{`Region ist erforderlich`}</div>
            )}
          </div>
          <div className="w3-col s6 pad-lr pad-top">
            <Label htmlFor="debitorKey">{`Kennung*`}</Label>
            <InputText
              id="debitorKey"
              data-test-id="debitorKey"
              className="w3-block w3-border"
              value={debitorKey}
              disabled={true}
              onChange={(event) => {
                const value = event.target.value;
                setState((prev) => ({ ...prev, debitorKey: value }));
              }}
            />
          </div>
        </div>
        <div className="w3-row">
          <div className="w3-col s6 pad-lr pad-top">
            <h4 className="no-margin-">{`Lieferanschrift*`}</h4>
            <CompanyAddressForm
              ref={addressFormRef}
              model={companyAddress}
              isVertical
              namePrefix="debitor_"
              companies={contractors}
              company={company}
              getCompany={getCompany}
              disabled={disabled || inUse}
            />
          </div>
          <div className="w3-col s6 pad-lr pad-top">
            <h4 className="no-margin-">{`Ansprechpartner`}</h4>
            <PersonForm
              ref={personFormRef}
              model={person}
              workers={workers}
              disabled={disabled || inUse}
            />
          </div>
        </div>
      </div>
      <div className="pad-top">
        <Label htmlFor="comment">{`Bemerkungen`}</Label>
        <InputTextarea
          id="comment"
          data-test-id="comment"
          className="w3-block w3-border"
          value={comment}
          rows={3}
          autoResize
          onChange={(event) => {
            const value = event.target.value;
            setState((prev) => ({ ...prev, comment: value }));
          }}
          disabled={disabled || inUse}
        />
      </div>
    </div>
  );
});

export default DebitorForm;
